import { buildModelManager } from "../builder.js";
const DefaultAiUsageDailySelection = {
  __typename: true,
  id: true,
  count: true,
  createdAt: true,
  date: true,
  failureReason: true,
  operationType: true,
  shopId: true,
  status: true,
  totalCachedTokens: true,
  totalCostUsd: true,
  totalInputTokens: true,
  totalOutputTokens: true,
  updatedAt: true
};
const modelApiIdentifier = "aiUsageDaily";
const pluralModelApiIdentifier = "aiUsageDailies";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAiUsageDailySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAiUsageDailySelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAiUsageDailySelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAiUsageDailySelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAiUsageDailySelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAiUsageDailySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAiUsageDailySelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "aiUsageDailyGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AiUsageDailyManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAiUsageDailySelection,
  operations
);
export {
  AiUsageDailyManager,
  DefaultAiUsageDailySelection
};
//# sourceMappingURL=AiUsageDaily.js.map
